// config.js
const config = {
    currentEvent: "LACNIC45",
    pastEvent: "LACNIC44", 
    REACT_APP_EVENT_SLUG:"LACNIC45",
    REACT_APP_PAST_EVENT_SLUG:"LACNIC44",
    REACT_APP_API_URL_BASE: "https://apievt.lacnic.net/wp-json",
    REACT_APP_API_URL: "https://apievt.lacnic.net/wp-json/wp/v2",
    REACT_APP_API_URL_MENU: "https://apievt.lacnic.net/wp-json/menus/v1/menus",
    lacnogEvent: "LACNOG 2022",
    eventDate: "2025/03/10",
    // ID del evento actual
    currentEventID: 250, 
    currentEventID_en: 251, 
    currentEventID_pt_br: 252,
    // ID del evento pasada
    pastEventID: 226,
    pastEventID_en: 227,
    pastEventID_pt_br: 228,
    // Archivos de configuración Zona Horaria: HourRow.jsx, TimeZoneState.jsx
    eventTimeZone: 'America/Panama',
    utcEventTimeZone: 'GMT-0500',
    currentEventCountry: 'Panamá',
    currentEventCountryCode: 'PA',
    currentEventCountryFlag: '🇵🇦',
    currentEventPlace: 'Panamá, Panamá', 
    // URLs importantes
    registrationURL: 'https://eventos.lacnic.net/ev4/detail?id=lacnic38',
    menuEditorURL: 'https://apievt.lacnic.net/wp-admin/nav-menus.php?action=edit&menu=0&lang=es&admin_bar=1',
    pagesSetupCreatorURL: 'https://apievt.lacnic.net/wp-admin/post-new.php?post_type=pages-setup&lang=es',
    homepageCreatorURL: 'https://apievt.lacnic.net/wp-admin/post-new.php?post_type=homepage&lang=es',
    ftlCreatorURL: 'https://apievt.lacnic.net/wp-admin/post-new.php?post_type=participate&lang=es',
    // Menu
    useAppMenu: false, // Cambia a true cuando quieras usar el menú de la app
  };
  
export default config;
  